import { authFetch } from "~/services/fetch";

export async function getAllWarehouseCheckoutStatus() { 
  try {
    const response = await authFetch({
      url: '/warehouse-checkout/warehouse-status',
      method: 'GET',
    });
    return response.data;
  } catch (error) { 
    console.error('Error fetching warehouse checkout status:', error);
  }
}